import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { Translate, LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import Routes from 'src/core/Routes';
import "./OccupationDb.less";
import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';
import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import OccupationDTO from 'src/models/occupation/OccupationDTO';
import Button from 'antd/lib/button/button';
import { Tooltip } from 'antd';

import OccupationApiController from 'src/api/OccupationApiController';
import { Occupation } from '../../games/JobMatchingGame/objects/Occupation';
import './OccupationDb.less';

interface OccupationDbProps extends PageProps<{}>, LocalizeContextProps {
}

interface OccupationDbState {
    loading: boolean;
    tableRecords: OccupationDTO[];
    formRedirect: boolean;
}
class OccupationDb extends React.Component<OccupationDbProps, OccupationDbState> {
    constructor(props: OccupationDbProps) {
        super(props);
        bindAllOfThis(this, OccupationDb.prototype);
        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private customTableColumns(): DataTableColumnProps<OccupationDTO>[] {
        let route: string = this.props.location.pathname.includes('admin') ? Routes.ADMIN_OCCUPATION : Routes.OCCUPATION;
        let viewLInk = (text, record: OccupationDTO) => Routes.getRoute(route, record.occupationId);

        return [
            DataTable.StandardColumns.Text("public.occupationdb.occupation", 'title'),
            DataTable.StandardColumns.Text("public.occupationdb.hollandcode", 'hollandCode'),
            DataTable.StandardColumns.Link("admin.common.emulateColumnHeader", 'occupationid', viewLInk, 'search')
        ];
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<OccupationDTO>) => void): void {
        this.setState({ loading: true });

        OccupationApiController.getOccupationsTableData(requestState, { additionalHeaders: { CultureCode: this.props.activeLanguage.code } })
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    render() {
        return (
        <div className="occupationDb">
                <h2><Translate id="public.occupationdb.title" /></h2>
                <DataTable
                    serverSide={true}
                    tableProps={{ rowKey: 'occupationId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[new DataTableButtonReset()]} />
        </div>
        );
    }
}

export default withLocalize(OccupationDb);



// WEBPACK FOOTER //
// ./src/pages/public/OccupationDb.tsx